exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__FHAPanel__panel__2-kkU {\n  background: white;\n  height: auto;\n  position: relative;\n}\n\n.dmb-web__FHAPanel__segment__Qxe0t {\n  background-color: #eee;\n  padding: 10px 0;\n  position: sticky;\n  text-align: center;\n  top: 0;\n  z-index: 1;\n}\n\n.dmb-web__FHAPanel__tabs__1t60F {\n  background-color: white;\n  text-align: center;\n}\n\n.dmb-web__FHAPanel__events__3sb1M {\n  background: white;\n  height: auto;\n}\n", ""]);

// exports
exports.locals = {
	"panel": "dmb-web__FHAPanel__panel__2-kkU",
	"segment": "dmb-web__FHAPanel__segment__Qxe0t",
	"tabs": "dmb-web__FHAPanel__tabs__1t60F",
	"events": "dmb-web__FHAPanel__events__3sb1M"
};